module.exports = __webpack_public_path__ + "img/photo-1-2.461ad322.webp";